import React, { useMemo } from "react";

const COLOR = {
  off: '#ffb000',
  on: '#fff',
  disabled: '#444',
}

type Props = {
  theme?: keyof typeof COLOR;
  size?: number;
};

export const CalendarIcon = ({ theme = 'off', size = 20 }: Props) => {
  const color = useMemo(() => COLOR[theme], [theme]);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 19" width={size} height={size}>
      <g id="レイヤー_2" data-name="レイヤー 2">
        <g id="レイヤー_1-2" data-name="レイヤー 1">
          <path
            fill={color}
            d="M19,1.58V19H0V1.58H2.38v.8a1.58,1.58,0,0,0,3.16,0v-.8h7.92v.8a1.58,1.58,0,0,0,3.16,0v-.8ZM17.42,6.33H1.58V17.42H17.42ZM15.83.79a.79.79,0,1,0-1.58,0V2.38a.79.79,0,0,0,1.58,0ZM4.75,2.38a.79.79,0,0,1-1.58,0V.79a.79.79,0,0,1,1.58,0ZM10,13.05a1.37,1.37,0,0,0-.87-1.34,1.27,1.27,0,0,0,.66-1.19,1.88,1.88,0,0,0-2-1.7A2,2,0,0,0,5.68,11H7c0-.6.22-1,.81-1a.69.69,0,0,1,.74.69c0,.6-.64.68-1.24.63v1c.85,0,1.35.06,1.35.78a.8.8,0,0,1-.86.83c-.65,0-.92-.48-.94-1.15H5.54A2.06,2.06,0,0,0,7.79,15,2.05,2.05,0,0,0,10,13.05Zm3.42,2V8.93h-1.1c-.14.92-.79,1.18-1.72,1.16v1.06H12.1V15Z"
          />
        </g>
      </g>
    </svg>
  );
};
